module.exports = __webpack_public_path__ + "static/media/sf-trial-2.ccc649be.mp3";